
<template>
  <vs-popup class="holamundo view-merchant" popup-class="w-9/12" :title='"جزئیات پذیرنده \""+shopName+"\""' :active.sync="popupActive">
    <ul class="vx-timeline" v-if="mmm.profile">
      <li>
        <div class="timeline-icon bg-success">
          <feather-icon icon="UserIcon" svgClasses="text-white stroke-current w-5 h-5" />
        </div>
        <div class="timeline-info">
          <span class="header-title">اطلاعات شخصی</span>
          <div class="activity-desc">
            <table class="w-full nav-info">
              <tr>
                <td class="property-title">تلفن همراه</td>
                <td>{{ mmm.mobile }}</td>
                <td class="property-title pl-12">کد ملی</td>
                <td>{{ mmm.profile.nationalCode }}</td>
              </tr>
              <tr>
                <td class="property-title">نام</td>
                <td>{{ mmm.profile.firstname }}</td>
                <td class="property-title pl-12">First Name</td>
                <td>{{ mmm.profile.firstnameEn }}</td>
              </tr>
              <tr>
                <td class="property-title">نام خانوادگی</td>
                <td>{{ mmm.profile.lastname }}</td>
                <td class="property-title pl-12">Last Name</td>
                <td>{{ mmm.profile.lastnameEn }}</td>
              </tr>
              <tr>
                <td class="property-title">نام پدر</td>
                <td>{{ mmm.profile.dadname }}</td>
                <td class="property-title pl-12">Father Name</td>
                <td>{{ mmm.profile.dadnameEn }}</td>
              </tr>
              <tr>
                <td class="property-title">شماره شناسنامه</td>
                <td>{{ mmm.profile.birthCrtfctNumber }}</td>
                <td class="property-title pl-12">سریال شناسنامه</td>
                <td>
                  {{ mmm.profile.birthCrtfctSerial}}
                  -
                  {{ mmm.profile.birthCrtfctSeriesNumber }}
                  /
                  {{ birthCrtfctSeriesLetterList[mmm.profile.birthCrtfctSeriesLetter].label }}
                </td>
              </tr>
              <tr>
                <td class="property-title">جنسیت</td>
                <td>
                  {{ mmm.profile.gender?
                  'مرد'
                  :'زن'}}
                </td>
                <td class="property-title pl-12">تاریخ تولد</td>
                <td>
                  {{ mmm.profile.birthdate?$moment(
                  mmm.profile.birthdate,
                  "YYYY/MM/DD"
                  ).format("jYYYY/jM/jD"):'' }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- <small class="text-grey activity-e-time">ههههههههه</small> -->
      </li>
      <li class="mt-12" >
        <div class="timeline-icon bg-success">
          <feather-icon icon="FileIcon" svgClasses="text-white stroke-current w-5 h-5" />
        </div>
        <div class="timeline-info">
          <span class="header-title">اطلاعات شخص حقوقی</span>
          <div class="activity-desc">
            <span v-if="!mmm.merchant.isLegal">
              شخصیت حقیقی است
            </span>
            <table class="w-full nav-info" v-else>
              <tr>
                <td class="property-title">نام شرکت</td>
                <td>{{ mmm.merchant.coName }}</td>
                <td class="property-title pl-12">Company Name</td>
                <td>{{ mmm.merchant.coNameEn }}</td>
              </tr>
              <tr>
                <td class="property-title">شناسه ملی اشخاص حقوقی</td>
                <td>{{ mmm.merchant.nationalLegalCode }}</td>
                <td class="property-title pl-12">کد اقتصادی</td>
                <td>{{ mmm.merchant.commercialCode }}</td>
              </tr>
              <tr>
                <td class="property-title">شماره ثبت شرکت</td>
                <td>{{ mmm.merchant.registerNumber }}</td>
                <td class="property-title pl-12">تاریخ ثبت شرکت</td>
                <td>
                  {{mmm.merchant.registerDate?$moment(
                  mmm.merchant.registerDate,
                  "YYYY/MM/DD"
                  ).format("jYYYY/jM/jD"):'' }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- <small class="text-grey activity-e-time">ههههههههه</small> -->
      </li>
      <li class="mt-12">
        <div class="timeline-icon bg-success">
          <feather-icon icon="CreditCardIcon" svgClasses="text-white stroke-current w-5 h-5" />
        </div>
        <div class="timeline-info">
          <span class="header-title">اطلاعات ترمینال</span>
          <div class="activity-desc">
            <table class="w-full nav-info">
              <tr>
                <td class="property-title">نام کاربری</td>
                <td>{{ mmm.merchant.terminalUserName }}</td>
                <td class="property-title pl-12">رمز عبور</td>
                <td>{{ mmm.merchant.terminalPassword }}</td>
              </tr>
              <tr>
                <td class="property-title">کد پذیرندگی</td>
                <td>{{ mmm.merchant.acceptorCode }}</td>
                <td class="property-title pl-12">شماره ترمینال</td>
                <td>{{ mmm.merchant.terminalId }}</td>
              </tr>
              <tr>
                <td class="property-title">کد پیگیری</td>
                <td>{{ mmm.merchant.trackingNumberPsp }}</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- <small class="text-grey activity-e-time">ههههههههه</small> -->
      </li>
      <li class="mt-12">
        <div class="timeline-icon bg-success">
          <feather-icon icon="AwardIcon" svgClasses="text-white stroke-current w-5 h-5" />
        </div>
        <div class="timeline-info">
          <span class="header-title">اطلاعات کسب و کار</span>
          <div class="activity-desc">
            <table class="w-full nav-info">
              <tr>
                <td class="property-title">نوع تجارت</td>
                <td>{{Object.entries(BusinessType).find(x=>x[1].value==1)[1].title }}</td>
              </tr>
              <tr>
                <td class="property-title">نام فروشگاه</td>
                <td>{{ mmm.merchant.shopName }}</td>
                <td class="property-title pl-12">Shop Name</td>
                <td>{{ mmm.merchant.shopNameEn }}</td>
              </tr>
              <tr>
                <td class="property-title">صنف</td>
                <td>{{(this.businessCategoryList.find(x=>x.value==mmm.merchant.businessCategoryId)||{}).label }}</td>
                <td class="property-title pl-12">زیرصنف</td>
                <td v-if="this.businessSubCategoryList.find(x=>x.value==mmm.merchant.businessSubCategoryId)">{{(this.businessSubCategoryList.find(x=>x.value==mmm.merchant.businessSubCategoryId)||{}).label }}</td>
              </tr>
              <tr>
                <td class="property-title">شماره شبا</td>
                <td>{{ mmm.merchant.defaultIban }}</td>
                <td class="property-title pl-12">شماره جواز کسب</td>
                <td>{{ mmm.merchant.businessCertificateNumber }}</td>
              </tr>
              <tr>
                <td class="property-title">تاریخ صدور جواز کسب</td>
                <td>
                  {{mmm.merchant.certificateIssueDate?$moment(
                  mmm.merchant.certificateIssueDate,
                  "YYYY/MM/DD"
                  ).format("jYYYY/jM/jD")
                  :'' }}
                </td>
                <td class="property-title pl-12">تاریخ اعتبار جواز کسب</td>
                <td>
                  {{mmm.merchant.certificateExpiryDate?$moment(
                  mmm.merchant.certificateExpiryDate,
                  "YYYY/MM/DD"
                  ).format("jYYYY/jM/jD"):'' }}
                </td>
              </tr>
              <tr>
                <td class="property-title">کد مالیاتی</td>
                <td>{{mmm.merchant.taxPayerCode}}
                </td>
                <td class="property-title">نوع مالکیت</td>
                <td>
                  {{ mmm.merchant.isRental
                  ?'اجاره‌ای'
                  :'ملکی' }}
                </td>
              </tr>
              <tr v-if="mmm.merchant.isRental">
                <td class="property-title">تاریخ اتمام قرارداد اجاره</td>
                <td>
                  {{ mmm.merchant.rentalExpiryDate?$moment(
                  mmm.merchant.rentalExpiryDate,
                  "YYYY/MM/DD"
                  ).format("jYYYY/jM/jD"):'' }}
                </td>
                <td class="property-title pl-12">شماره قرارداد اجاره</td>
                <td>{{ mmm.merchant.rentalContractNumber }}</td>
              </tr>
              <tr>
                <td class="property-title">استان</td>
                <td>{{(this.provinceList.find(x=>x.value==mmm.merchant.provinceCode)||{}).label }}</td>
                <td class="property-title pl-12">شهر</td>
                <td v-if="this.cityList.find(x=>x.value==mmm.merchant.cityCode)">{{(this.cityList.find(x=>x.value==mmm.merchant.cityCode)||{}).label }}</td>
              </tr>
              <tr>
                <td class="property-title">تلفن</td>
                <td>{{ mmm.merchant.telephoneNumber }}</td>
                <td class="property-title pl-12">فکس</td>
                <td>{{ mmm.merchant.fax }}</td>
              </tr>
              <tr>
                <td class="property-title">وبسایت</td>
                <td>{{ mmm.merchant.webSite }}</td>
                <td class="property-title pl-12">ایمیل</td>
                <td>{{ mmm.merchant.email }}</td>
              </tr>
              <tr>
                <td class="property-title">کد پستی</td>
                <td>{{ mmm.merchant.postalCode }}</td>
              </tr>
              <tr>
                <td class="property-title">آدرس</td>
                <td colspan="3">{{ mmm.merchant.address }}</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- <small class="text-grey activity-e-time">ههههههههه</small> -->
      </li>
    </ul>
  </vs-popup>
</template>
<style lang="scss" >
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
.header-title{
  color:#333;
  
}
.activity-desc{
      margin-top: 12px;
      margin-bottom: 48px;
}
table.nav-info {
    line-height: 16pt;
  td{
    vertical-align: top;

  }
  .property-title
   {
    width: 1%;
    white-space: nowrap;
    &:after {
      content: ":";
    }
    color:#777;
    padding-left: 3px;
  }
  :not(.property-title){
    min-width: 50px;
    color:#333;
  }
}
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
.view-merchant > .vs-popup {
  width: 80% !important;
}
</style>
<script>
import { BusinessType,BirthCrtfctSeriesLetter } from "@/enums.js";
export default {
  name: "view-merchant",
  props: {},
  components: {
  },
  data() {
    return {
      mmm: {},
      popupActive: false,
      BusinessType,
      businessCategoryList: [],
      businessSubCategoryList: [],
      provinceList: [],
      cityList: [],
      BirthCrtfctSeriesLetter,
      shopName:'',
    };
  },
  computed: {
    birthCrtfctSeriesLetterList: function() {
      let ms = [];
      for (let [key, value] of Object.entries(this.BirthCrtfctSeriesLetter)) {
        ms.push({ value: key, label: value.text });
      }
      return ms;
    }
  },
  methods: {
    show(id,shopName) {
      this.getMerhant(id);
      this.popupActive = true;
      this.shopName=shopName;
    },
    getMerhant(id) {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          id: id
        }
      };
      this.$http
        .get("/api/services/app/Merchants/GetMerchantForEdit", payload)
        .then(async response => {
          this.mmm = response.data.result;
          this.getbusinessSubCategoryList(this.mmm.merchant.businessCategoryId);
          this.getCityList(this.mmm.merchant.provinceCode);
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http

    },
    getbusinessCategoryList() {
      let payload = {
        params: {
          MaxResultCount: 9999
        }
      };
      this.$http
        .get("/api/services/app/BusinessCategories/GetAll", payload)
        .then(response => {
          this.businessCategoryList = response.data.result.items.map(x => {
            return {
              label: x.businessCategory.description,
              value: x.businessCategory.id
            };
          });
          this.businessSubCategoryList = [];
        }) //end success
        .catch(error => {}); //end http
    },
    async getbusinessSubCategoryList(item) {
      if (item == null) return;
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          BusinessCategoryIdFilter: item,
          MaxResultCount: 9999
        }
      };
      await this.$http
        .get("/api/services/app/BusinessSubCategories/GetAll", payload)
        .then(response => {
          this.selectedBusinessSubCategory = null;
          this.businessSubCategoryList = response.data.result.items.map(x => {
            return {
              label: x.businessSubCategory.description,
              value: x.businessSubCategory.id
            };
          });
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    getProvinceList() {
      let payload = {
        params: {
          MaxResultCount: 9999
        }
      };
      this.$http
        .get("/api/services/app/Province/GetAll", payload)
        .then(response => {
          this.provinceList = response.data.result.items.map(x => {
            return {
              label: x.province.name,
              value: x.province.code
            };
          });
        }) //end success
        .catch(error => {}); //end http
    },
    async getCityList(item) {
      if (item == null) return;
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          ProvinceCodeFilter: item,
          MaxResultCount: 9999
        }
      };
      await this.$http
        .get("/api/services/app/City/GetAll", payload)
        .then(response => {
          this.selectedCity = null;
          this.cityList = response.data.result.items.map(x => {
            return {
              label: x.city.name,
              value: x.city.code
            };
          });
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    }
  },
  mounted() {
    this.getbusinessCategoryList();
    this.getProvinceList();
  }
};
</script>